//使用axios请求数据
import axios from "axios";




/* 游戏攻略列表 */
let playSceniclist = data => {
  return axios.post("/play_scenic/area/detail/listing", data);
};

/* 游戏攻略列表 */
let playScenicDetail = data => {
  return axios.post("/play_scenic/area/detail", data);
};

/* 留言 */
let commentAdd = data => {
  return axios.post("/comment/add", data);
};

/* 留言列表 */
let commentlist = data => {
  return axios.post("/comment/listing", data);
};

/* 留言点赞 */
let commentGive = data => {
  return axios.post("/comment/give", data);
};

/* 公司介绍 */
let companyProfile = data => {
  return axios.post("/company/detail", data);
};

/* 预定类型 */
let typelist = data => {
  return axios.post("/reserve/type/listing", data);
};

/* 预定列表 */
let reserveDatalist = data => {
  return axios.post("/reserve/project/listing", data);
};

/* 景点列表 */
let scenicSpotlist = data => {
  return axios.post("/scenic_spot/listing", data);
};






export { playSceniclist,playScenicDetail,commentlist,commentAdd,commentGive,companyProfile,typelist,reserveDatalist,scenicSpotlist };



// WEBPACK FOOTER //
// ./src/api/api.js